"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "carrega-ligure": {
    "08793f11": [{
      "hkey": "453a1334",
      "slug": "carrega-ligure",
      "name": "Carrega Ligure",
      "primary": true,
      "skipSearch": false
    }],
    "berga": [{
      "hkey": "453a1334",
      "slug": "carrega-ligure",
      "name": "Carrega Ligure",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "01097569": [{
      "hkey": "453a1334",
      "slug": "carrega-ligure",
      "name": "Carrega Ligure",
      "primary": true,
      "skipSearch": false
    }],
    "campassi": [{
      "hkey": "453a1334",
      "slug": "carrega-ligure",
      "name": "Carrega Ligure",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1c7e9db5": [{
      "hkey": "453a1334",
      "slug": "carrega-ligure",
      "name": "Carrega Ligure",
      "primary": true,
      "skipSearch": false
    }],
    "magioncalda": [{
      "hkey": "453a1334",
      "slug": "carrega-ligure",
      "name": "Carrega Ligure",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;